var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinrefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47 11.4197L2.73 9.67969L1 11.4197M19.53 12.5797L21.27 14.3197L23.01 12.5797",
    stroke: "#0A2432",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.26 14.3202V12.0002C21.26 6.88023 17.11 2.74023 12 2.74023C9.07999 2.74023 6.46999 4.10023 4.76999 6.21023M2.73999 9.68023V12.0002C2.73999 17.1202 6.88999 21.2602 12 21.2602C14.92 21.2602 17.53 19.9002 19.23 17.7902",
    stroke: "#0A2432",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6846 11.2286C11.3154 10.7229 10.6538 10.4057 10.6538 9.6C10.6538 8.72571 11.5077 8.40857 12.0462 8.40857C12.5578 8.40857 12.9048 8.6273 13.1336 8.88192C13.4057 9.18483 13.8432 9.39861 14.2114 9.22464C14.5056 9.0856 14.657 8.74976 14.5063 8.46136C14.2813 8.03121 13.8805 7.4908 13.2234 7.20613C12.9685 7.09571 12.7692 6.86369 12.7692 6.58593C12.7692 6.26233 12.5069 6 12.1833 6H11.8377C11.5025 6 11.2308 6.27172 11.2308 6.60689C11.2308 6.88503 11.0372 7.12029 10.783 7.23324C9.32182 7.88251 9.31538 9.53874 9.31538 9.61714C9.31538 11.5629 11.0462 12.1114 11.8923 12.4543C13.1077 12.9343 13.6462 13.3714 13.6462 14.1943C13.6462 15.1629 12.8385 15.5743 12.1231 15.5743C11.3127 15.5743 10.8374 15.0373 10.5718 14.5484C10.3675 14.1723 9.91684 13.9448 9.52648 14.1204C9.22232 14.2572 9.05506 14.5966 9.17774 14.9067C9.59924 15.9721 10.2952 16.4765 10.7992 16.7216C11.0488 16.843 11.2308 17.0823 11.2308 17.3599C11.2308 17.7134 11.5173 18 11.8708 18H12.1722C12.5019 18 12.7692 17.7327 12.7692 17.403C12.7692 17.1292 12.9578 16.8989 13.2143 16.803C13.8818 16.5535 15 15.8961 15 14.1771C15 12.9857 14.5308 11.94 12.6846 11.2286Z",
    fill: "#0A2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinrefresh);
export default __webpack_public_path__ + "static/media/coinrefresh.01ebc8a4456cd7942c404018bdfedd1b.svg";
export { ForwardRef as ReactComponent };